/**
 * Footer component.
 * @module components/theme/Footer/Footer
 */

import React from 'react';
import { Container, Segment } from 'semantic-ui-react';
import { injectIntl } from 'react-intl';
import { UniversalLink } from '@plone/volto/components';
import useAnalyticsPageview from '../../../../components/Blog/useAnalyticsPageview';

/**
 * Component to display the footer.
 * @function Footer
 * @param {Object} intl Intl object
 * @returns {string} Markup of the component
 */
const Footer = ({ intl }) => {
  useAnalyticsPageview();
  return (
    <Segment
      role="contentinfo"
      vertical
      padded
      inverted
      color="grey"
      textAlign="center"
      id="footer"
      className="ehon-footer"
    >
      <Container>
        <p className="ehon-footer-contact">
          感想・おすすめ絵本・お問い合わせ:{' '}
          <UniversalLink href="/contact">お問い合わせフォーム</UniversalLink>
        </p>
        <p className="ehon-footer-admin">
          <UniversalLink href="/login">管理者ログイン</UniversalLink>
        </p>
      </Container>
    </Segment>
  );
};

/**
 * Property types.
 * @property {Object} propTypes Property types.
 * @static
 */
Footer.propTypes = {
  /**
   * i18n object
   */
};

export default injectIntl(Footer);
